module.exports = __webpack_public_path__ + "static/media/Urgot_0.ee6736fc.png";